import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "../../lib/scroll";
import { useLang } from "../../lib/i18n";
import { LangToggle } from "./LangToggle";

const LINKS = [
  ["home", "nav-home-link"],
  ["order-pack", "nav-order-pack-link"],
  ["installation", "nav-installation-link"],
  ["contact-us", "nav-contact-link"],
];

export const Header = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[#E6D9BC]/10 bg-[#1E2A32]/75 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between px-5 md:h-20 md:px-10">
        <Logo onClick={() => go("home")} />
        <div className="flex items-center gap-6 md:gap-10">
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map(([id, tid], i) => (
            <button key={id} data-testid={tid} onClick={() => go(id)} className="sw-link font-mono text-xs uppercase tracking-[0.2em] text-[#BAC6CE] hover:text-[#F4EFE6]">
              <span className="mr-2 text-[#E6D9BC]/70">0{i + 1}</span>{t.nav[i]}
            </button>
          ))}
        </nav>
        <LangToggle />
        <button data-testid="mobile-menu-toggle" onClick={() => setOpen((o) => !o)} className="text-[#E6D9BC] lg:hidden" aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="flex flex-col gap-1 border-t border-[#E6D9BC]/10 bg-[#162026] px-5 py-6 lg:hidden">
          {LINKS.map(([id, tid], i) => (
            <button key={id} data-testid={`mobile-${tid}`} onClick={() => go(id)} className="py-3 text-left font-display text-3xl text-[#F4EFE6]">
              {t.nav[i]}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
};
